import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=42e5feac"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e5feac')) {
      api.createRecord('42e5feac', component.options)
    } else {
      api.reload('42e5feac', component.options)
    }
    module.hot.accept("./Curriculum.vue?vue&type=template&id=42e5feac", function () {
      api.rerender('42e5feac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Curriculum.vue"
export default component.exports